import pokerRoutes from '@/products/poker/routes'
import retroRoutes from '@/products/retro/routes'

export function routesForProduct(product) {
    const shared = [
        {path: '/account', name: 'Account', component: () => import('@/shared/views/Account.vue')},
        {path: '/auth/result', name: 'AuthResult', component: () => import('@/shared/views/AuthResult.vue')},
        {path: '/agent/authorize/:id', name: 'AgentAuthorization', component: () => import('@/shared/views/AgentAuthorization.vue')},
    ]
    if (product === 'site') return shared
    return [...shared, ...(product === 'retro' ? retroRoutes : pokerRoutes)]
}
